export const orderingBy = [
  {name: "Ціна: від вищої до нижчої", ordering: "-price"},
  {name: "Ціна: від нижчої до вищої", ordering: "price"},
  {name: "За знижкою", ordering: "-discount_percent"},
  {name: "За бонусними балами ", ordering: "-points_to_count"},
]
